import { Fragment, useEffect, useState } from 'react';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

import { WrongInvoiceService } from '../../xu-ly-sai-sot/thong-bao-04-ss-hddt/WrongInvoiceService';
import { TenantCompanyService } from '../../he-thong/doanh-nghiep/thong-tin-doanh-nghiep/TenantCompanyService';
import { AppStorage } from '../../../service/UserStorage';

import { FormatDisplay } from '../../../shared/format';

import { ToastService } from '../../../AppToast';
import { ConfirmDialogService } from '../../../AppConfirmDialog';

import { useForm } from '../../../shared/hooks/Form';
import { useCellEditing } from '../../../shared/hooks/CellEditing';
import { useSign } from '../../../shared/component/Sign';

export const DialogCancel = (props) => {

  const { display, setDisplay, selectedItems } = props;

  const [tenantData, setTenantData] = useState(null);

  const [submitting, setSubmitting] = useState(null);
  const [wrongInvoiceDetail, setWrongInvoiceDetail] = useState([]);

  const [firstId, setFirstId] = useState(null);

  const types = [
    { value: 1, label: 'Thông báo hủy/giải trình của Người nộp thuế' },
    { value: 2, label: 'Thông báo hủy/giải trình của Người nộp thuế theo thông báo của Cơ quan thuế' }
  ];

  const { render: renderForm, setValue, valid: formValid, getValue } = useForm({
    fields: [
      { field: 'type', header: 'Loại thông báo', required: true, type: 'Dropdown', DropdownProps: { options: types, filter: true, resetFilterOnHide: true }, className: 'md:col-8', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'documentNo', header: 'Số thông báo', required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-4', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8' },
      {
        field: 'taxAuthorityNotificationNo', header: 'Số thông báo từ CQT', InputTextProps: { maxLength: 400 }, className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8', displayDependency: (item) => {
          return item.type === 2;
        }
      },
      {
        field: 'taxAuthorityNotificationDate', header: 'Ngày thông báo từ CQT', type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8', displayDependency: (item) => {
          return item.type === 2;
        }
      },
      { field: 'taxAuthorityCode', type: 'hidden' },
      { field: 'taxAuthorityName', header: 'Cơ quan thuế tiếp nhận', required: true, InputTextProps: { maxLength: 400 }, disabled: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { type: 'custom', className: 'md:col-12', body: <i>Lưu ý: Để thông báo hoá đơn sai sót Quý khách hàng cần cập nhật đúng mã cơ quan thuế quản lý <a href="/#/he-thong/doanh-nghiep/thong-tin-doanh-nghiep" target="_blank">Tại đây</a></i> },
      { field: 'taxpayers', header: 'Tên người nộp thuế', required: true, InputTextProps: { maxLength: 400 }, disabled: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'taxCode', header: 'Mã số thuế', required: true, InputTextProps: { maxLength: 400 }, disabled: true, className: 'md:col-12', labelClassName: 'md:col-2', inputClassName: 'md:col-10' },
      { field: 'dateCreate', header: 'Ngày lập', required: true, type: 'Calendar', className: 'md:col-6', labelClassName: 'md:col-4', inputClassName: 'md:col-8' },
      { field: 'region', header: 'Nơi lập', required: true, InputTextProps: { maxLength: 400 }, className: 'md:col-6', labelClassName: 'md:col-4 justify-content-center', inputClassName: 'md:col-8' }
    ],
    layout: 'Horizontal'
  });

  useEffect(() => {
    TenantCompanyService.get(AppStorage.get('tenant')).then(data => {
      setTenantData(data);
    });
  }, []);

  const { render: renderDataTable } = useCellEditing({
    dataKey: 'invoiceId',
    columns: [
      {
        field: 'index', header: 'STT', style: { textAlign: 'center' }, dataType: 'custom', customCell(rowData: any, rowIndex): any {
          return rowIndex + 1;
        }
      },
      { field: 'denominator', header: 'Mẫu số', style: { minWidth: '80px', maxWidth: '80px' } },
      { field: 'invoiceSerial', header: 'Ký hiệu', style: { minWidth: '80px', maxWidth: '80px' } },
      { field: 'invoiceNumber', header: 'Số hoá đơn', style: { minWidth: '80px', maxWidth: '80px' } },
      { field: 'invoiceDate', header: 'Ngày hoá đơn', dataType: 'date', style: { minWidth: '100px', maxWidth: '100px' } },
      { field: 'typeInvoiceName', header: 'Loại hoá đơn áp dụng', style: { minWidth: '180px', maxWidth: '180px' } },
      { field: 'propertyName', header: 'Tính chất thông báo', style: { minWidth: '140px', maxWidth: '140px' } },
      { field: 'reason', header: 'Lý do sai sót *', editable: true, style: { minWidth: '120px' } },
      { field: 'taxAuthorityCode', header: 'Mã cơ quan thuế cấp', style: { minWidth: '130px', maxWidth: '130px' } }
    ],
    items: wrongInvoiceDetail,
    onCellChange: (rowData, column, newValue) => {
      const _items = [...wrongInvoiceDetail];
      for (const _item of _items) {
        if (_item['invoiceId'] === rowData['invoiceId']) {
          _item[column.field] = newValue;
        } else if (firstId === rowData.id && ['reason'].includes(column.field)) {
          _item[column.field] = newValue;
        }
      }
      setWrongInvoiceDetail(_items);
    }
  });

  const onShow = () => {
    if (tenantData) {
      setValue({
        type: 1,
        documentNo: `TB-${FormatDisplay.date(new Date(), 'DDMMYYYY_HHmm')}`,
        taxAuthorityCode: tenantData.taxAuthorityCode,
        taxAuthorityName: tenantData.taxAuthorityName,
        taxpayers: tenantData.name,
        taxCode: tenantData.taxCode,
        region: tenantData.province,
        dateCreate: new Date()
      });
    }
    if (selectedItems) {
      let _selectedItems;
      if (!Array.isArray(selectedItems)) {
        _selectedItems = [selectedItems];
      } else {
        _selectedItems = [...selectedItems];
      }
      const _items = [];
      _selectedItems.forEach(selectedItem => {
        _items.push({
          id: selectedItem.id,
          invoiceId: selectedItem.id,
          denominator: selectedItem.invoiceSerial.substring(0, 1),
          invoiceSerial: selectedItem.invoiceSerial.substring(1, selectedItem.invoiceSerial.length),
          invoiceNumber: `${selectedItem.invoiceNumber}`,
          invoiceDate: new Date(selectedItem.invoiceDate),
          typeInvoice: 1,
          typeInvoiceName: 'Hóa đơn điện tử theo NĐ123',
          property: 1,
          propertyName: 'Hủy',
          reason: '',
          taxAuthorityCode: selectedItem.taxAuthorityCode || ''
        });
      });
      _items.sort((a, b) => {
        return a.invoiceNumber - b.invoiceNumber
      });
      if (_items.length) {
        setFirstId(_items[0].id);
      }
      setWrongInvoiceDetail(_items);
    }
  }

  const { renderSign, sign } = useSign({ onComplete: null });

  const handleSubmit = () => {
    if (wrongInvoiceDetail && wrongInvoiceDetail.length) {
      let valid = true, orders = 1;
      const _wrongInvoiceDetail = [];
      wrongInvoiceDetail.forEach(wrongInvoice => {
        if (!wrongInvoice.reason) {
          valid = false;
          ToastService.error(`Lý do sai sót hoá đơn số ${wrongInvoice.invoiceNumber} không được để trống.`);
        }
        const invoice = Object.assign({}, wrongInvoice);
        invoice.orders = orders;
        invoice.invoiceDate = FormatDisplay.date(invoice.invoiceDate, 'YYYY-MM-DDTHH:mm:ss');
        _wrongInvoiceDetail.push(invoice);
        orders++;
      });
      if (valid && formValid() && !submitting) {

        setSubmitting(true);

        const data = getValue();
        data.wrongInvoiceDetail = _wrongInvoiceDetail;

        WrongInvoiceService.create(data).then(({ id }) => {
          if (id) {
            ToastService.success();
            setDisplay(false);
            ConfirmDialogService.setProps({
              message: 'Bạn có muốn gửi thông báo hóa đơn sai sót đến Cơ quan thuế theo mẫu 04/SS-HĐĐT ngay không?',
              header: 'Ký gửi 04/SS-HĐĐT',
              icon: 'pi pi-info-circle',
              acceptClassName: 'p-button-primary',
              acceptLabel: 'Đồng ý',
              rejectLabel: 'Không, Tôi sẽ gửi sau',
              accept: () => {
                sign({
                  "CommandName": "SignSS04",
                  "Id": id
                });
              }
            });
          } else {
            ToastService.error();
          }
        }).finally(() => {
          setSubmitting(false);
        });
      }
    } else {
      ToastService.error('Danh sách hoá đơn không hợp lệ');
    }
  }

  return (
    <Fragment>
      <Dialog header="Khai báo thông tin hoá đơn sai sót" visible={display} style={{ width: '90rem' }} draggable={false} resizable={true} position="top"
        onHide={() => setDisplay(false)} onShow={onShow} className="view-invoice">
        <div className="grid">
          <div className="col-12">
            {renderForm()}
          </div>

          <div className="col-12">
            {renderDataTable()}
          </div>
        </div>

        <div className="flex justify-content-end">
          <Button label="Đóng" icon="pi pi-times" onClick={() => setDisplay(false)} className="p-button-text p-button-sm" />
          <Button label="Lưu" icon="pi pi-check" onClick={handleSubmit} loading={submitting} className="p-button-sm" />
        </div>
      </Dialog>
      {renderSign()}
    </Fragment>
  );
}